import React from "react";
import { Link, DisabledPrompt } from "bcms-react";
import { TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { TableBody } from "components/shared/views/TableView";

/**
 * @function FastBalancesDevicesTable
 * @return {React.Component}
 * @exported true
 * @description The main component for FastBalancesDevicesTable
 */
export default function FastBalancesDevicesTable(props) {
    const mobileDevices = props.mobileDevices ?? [];
    const rows = mobileDevices.reduce((acc, device) => {
        acc.push(<FastBalancesDevicesRow key={ device.id } device={ device } />);
        return acc;
    }, []);

    return (
        <TableView className="fast-balances-devices-table">
            <TableColumnContainer>
                <TableColumnView className="text-left" text="Device" />
            </TableColumnContainer>
            <TableBody>
                { rows }
            </TableBody>
        </TableView>
    )
}

/**
 * @function FastBalancesDevicesRow
 * @return {React.Component}
 * @exported true
 * @description The main component for FastBalancesDevicesRow
 */
export function FastBalancesDevicesRow(props) {
    const device = props.device ?? {};

    return (
        <TableItemContainer>
            <TableItemTextView text={ device.name } dataPoint={ `Device_Name_${ device.id }` } />
            <TableItemView>
                <DisabledPrompt>
                    <Link dataPoint={ `Device_Delete_Button_${ device.id }` }>Delete</Link>
                </DisabledPrompt>
            </TableItemView>
        </TableItemContainer>
    )
}

